const getTransmissionLinksQuery = /* GraphQL */ `
  query {
    links: transmissionLinks {
      href: url
      primary: displayName
    }
  }
`

export default getTransmissionLinksQuery
